import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import UserBookshelf from 'rebook/apps/users/components/UserBookshelf';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import { URLS } from 'rebook/apps/base/constants';
import Button from 'rebook/apps/base/components/Button';

import styles from './style.scss';


class UserBookshelvesView extends React.Component {
  constructor(props) {
    super(props);
    this.paginateBy = 10;

    this.state = {
      bookshelves: [],
      pageNumber: 1,
      lastPageNumber: 1,
    };
  }

  componentDidMount() {
    this.changePage(1);
  }

  changePage(pageNumber = 1) {
    const offset = pageNumber > 1 ? (pageNumber - 1) * this.paginateBy: 0;
    const url = `/api/bookshelf/?limit=${this.paginateBy}&offset=${offset}`;
    fetchQuery(url, { apiVersion: 3 })
      .then(
        ({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / this.paginateBy);
          this.setState({
            bookshelves: data.objects,
            pageNumber: pageNumber,
            lastPageNumber: lastPageNumber,
          });
        }
      );
  }

  render() {
    const { user } = this.props;
    const userId = parseInt(this.props.match.params.userId, 10);

    if (!user || userId !== user.id) {
      return <Redirect to={URLS.dashboard} />;
    }

    const { bookshelves } = this.state;
    const createBookshelveUrl = `/profile/${this.props.match.params.userId}/editbookshelf`;

    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Мои книги', url: `/profile/${this.props.match.params.userId}/` },
            { text: 'Мои полки', url: get(this, 'props.location', '') },
          ]} />
        </div>
        <div className="col-md-6">
          <div className="title-1">Мои полки</div>
          <Button url={createBookshelveUrl} extraClassName="jest-create-bookshelf-button">
            Создать полку
          </Button>
          {bookshelves && (
            <div className={classNames(styles.bookshelfList, 'jest-bookshelf-list')}>
              {bookshelves.length > 0 && (
                bookshelves.map((bookshelf) => (
                  <UserBookshelf
                    extraClassName={styles.bookshelf}
                    bookshelf={bookshelf}
                    userId={user.id}
                    key={bookshelf.id} />
                ))
              )}
              <ContextPagination
                extraClassName="jest-bookshelf-list-pagination"
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={this.state.pageNumber}
                lastPage={this.state.lastPageNumber} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(UserBookshelvesView);
